import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as UserActions1 from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'addStaff';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import { cutom_utils } from '../../../ucd_utils/util';


export var AddStaff = React.createClass({
    getInitialState() {
        return {
            showAddStaffSuccessModal: false,
            showFailureModel: false,
            modal_msg: null,
            form_submited: false,

            previlizedUser: false,
            mobileCssClass: "inputText",
        }
    },

    componentWillMount() {

        var facility_id = this.props.UserDetails.selectdUserFacilityID;

    },

    componentWillReceiveProps(nextProps) {
        if (this.state.form_submited && nextProps.FacilitiesDetails.FaciliteAdmin) {
            nextProps.FacilitiesDetails.FaciliteAdmin.status == 200 ? this.setState({ showAddStaffSuccessModal: true, modal_msg: nextProps.FacilitiesDetails.FaciliteAdmin.message }) : this.setState({ showFailureModel: true, modal_msg: nextProps.FacilitiesDetails.FaciliteAdmin.message });
            nextProps.FacilitiesDetails.FaciliteAdmin = null;
        }
    },

    email_validate(event) {
        let email = event.target.value;
        let isValidEmail = validate.email(email);
        isValidEmail ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phon_validate(event) {
        let mobile = event.target.value;
        let isValidMobile = validate.phone(mobile);
        isValidMobile ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },

    closebox() {
        this.setState({ showAddStaffSuccessModal: false, showFailureModel: false });
    },
    closeBoxOnScuess() {
        this.props.router.push('/admin/staff');
        /*to get latest list*/
        let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
        //  this.props.Dispatch(UserActions1.getAllStaffData(facilitiesID));
    },
    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },
    sendAddStaffInvitaion() {

        //var facility_id =  window.location.search ? validate.getUrlParam('id') : window.location.hash === "#new" ?this.props.FacilitiesDetails.FaciliteCreateDeatils.data.id:this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;

        var facility_id = this.props.UserDetails.selectdUserFacilityID;
        let firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            email = this.refs.email.value.trim(),
            dobYear = this.refs.dobYear.value.trim(),
            facilityRoleId = this.refs.designation.value.trim();
        // therapist=this.refs.therapist.value.trim();

        let iEmailTrue = validate.email(email);
        let isPhoneTrue = validate.phone(mobile);

        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        !dobYear.length ? this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom' : this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown';
        !facilityRoleId.length ? this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom' : this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown';
        // !therapist.length ? this.refs.therapist.className += " error" : "";
        !iEmailTrue ? this.refs.email.className = "inputText error" : this.refs.email.className = "inputText";
        !isPhoneTrue ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });

        if (dobYear.length && firstName.length && lastName.length && mobile.length && iEmailTrue && isPhoneTrue && facilityRoleId.length) {

            var data = {
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,
                "email": email,
                "yearOfDob": dobYear,
                "createdBy":
                {
                    "id": this.props.UserDetails.loginData.data.id,
                    "role": { "id": this.props.UserDetails.selectedUserRoleID }
                },
                "facility": { "id": facility_id },
                "role": { "id": 8 },
                "facilityRole": { "id": facilityRoleId }
            }
            this.setState({ form_submited: true });
            this.props.Dispatch(FacilitiesActions.createFaclityAdmin(data));
        }
        else {

            this.setState({ showFailureModel: true, modal_msg: "Please enter necessary fields to proceed." });
        }


    },
    cancel() {
        this.props.router.push('/admin/staff')
    },

    ToglePrevilizedUser(e) {
        if (e.target.value != "true") {
            this.setState({ previlizedUser: false })
            //e.target.value = true;
        }
        else {
            this.setState({ previlizedUser: true })
            //e.target.value = false;
        }
    },
    render() {

        var getYrs = cutom_utils.getYears();
        var yearOptions = getYrs.map(function (years) {
            return <option key={years}
                value={years}>{years}</option>;
        });

        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} breadcrumb={true} />
                <div className="breadcrumb-custom">
                    <h2> <Link to="/patients">STAFF</Link> > ADD</h2>
                </div>
                <div className="white-box">
                    <div className="recovery-facility">
                        <h4>ADD STAFF</h4>
                        <div className="row">
                            <div className="col-xs-8 no-padding">
                                <div className="col-xs-12 no-padding staff-recovery">
                                    <div className="row">
                                        <div className="col-xs-6 padding-right-20">
                                            <div className="input-group">
                                                <input type="text" className="inputText" ref="firstName" onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required />
                                                <span className="floating-label">First Name</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 no-padding">
                                            <div className="input-group">
                                                <input type="text" className="inputText" ref="lastName" onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required />
                                                <span className="floating-label">Last Name</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 no-padding ">
                                            <div className="input-group">
                                                <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.email_validate} ref="email" required />
                                                <span className="floating-label">Email</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6 no-padding padding-right-20">
                                            <div className="input-group">
                                                <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} onBlur={this.phon_validate} ref="mobile" required mask="999 999 9999" maskChar={null}></InputMask>
                                                <span className="floating-label">Phone</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 no-padding ">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select ref="dobYear" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                            <option value="" default>Year of Birth</option>
                                                            {yearOptions}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-12 no-padding ">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select ref="designation" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                            {/* <option value="" default>Designation</option> */}
                                                            <option value="" default> Professional Role </option>
                                                            {/* <option value="3" >Psychiatrist Support Staff</option>
                                                            <option value="4" >Therapist</option>
                                                            <option value="5" >Other Support Staff</option>
                                                            <option value="6" >Administrative Staff</option> */}
                                                            <option value="9" >Clinician/Therapist</option>
                                                            <option value="10" >Prescriber/Psychiatrist/Other Medical Personnel</option>
                                                            <option value="11" >Clinical Supervisor/Team Lead</option>
                                                            <option value="12" >Clinic Coordinator</option>
                                                            <option value="13" >Administrative Support Staff</option>
                                                            <option value="14" >Family Advocate</option>
                                                            <option value="15" >Peer Support Specialist</option>
                                                            <option value="16" >Case Manager/Recovery Coach</option>
                                                            <option value="17" >Supported Education & Employment Specialist</option>
                                                            <option value="18" >Program Director</option>
                                                            <option value="19" >Research Staff/Site Coordinator</option>
                                                            <option value="20" >Other</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="row no-margin">
                                        <div className="col-xs-12">
                                            <div className="aj-switch">
                                        previlized User {this.state.previlizedUser === true ? <button ref="previlizedUserTrue" value='false' onClick={this.ToglePrevilizedUser}>YES</button> : <button ref="previlizedUserFalse" value='true' onClick={this.ToglePrevilizedUser}>NO</button>}
                                    </div>
                                    </div>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 no-padding recovery-buttons">
                                <button className="gray-button" onClick={this.sendAddStaffInvitaion}>Send Invite</button>
                                <button className="white-button" onClick={this.cancel} >cancel</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div> {this.state.showAddStaffSuccessModal ? <ModalDialogCommon message={this.state.modal_msg} action={this.closeBoxOnScuess} /> : ""}</div>
                <div> {this.state.showFailureModel ? <ModalDialogCommon message={this.state.modal_msg} action={this.closebox} /> : ""}</div>
            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        PatientsDetails: state.Patients,
        UserDetails: state.User,
        FacilitiesDetails: state.Facilites

    };
};

let mapDispatchToProps = (dispatch) => ({
    PatientsActions: bindActionCreators(PatientsActions, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AddStaff));



/** WEBPACK FOOTER **
 ** ./src/components/admin/staff/addStaff.js
 **/